import { __rest } from 'tslib';
import React from 'react';
import { isString } from '@10d/tend-ui-utils/isString';
import { ChevronRight } from '../../icons/ChevronRight/ChevronRight.js';
import { Content, Root } from './styled.js';

const BaseDropdown = React.forwardRef((_a, ref) => {
    var { children, content, dropdownRender, menu } = _a, props = __rest(_a, ["children", "content", "dropdownRender", "menu"]);
    const child = isString(children) ? React.createElement("span", null, children) : children;
    const _dropdownRender = React.useCallback((node) => {
        if (dropdownRender)
            return dropdownRender(node);
        if (content)
            return React.createElement(Content, null, content);
        return node;
    }, [content, dropdownRender]);
    const _menu = React.useMemo(() => (Object.assign({ expandIcon: React.createElement(ChevronRight, null) }, menu)), [menu]);
    return (React.createElement(Root, Object.assign({}, props, { ref: ref, dropdownRender: _dropdownRender, menu: _menu }), child));
});
const Dropdown = Object.assign(BaseDropdown, {
    displayName: 'Dropdown',
});

export { Dropdown };
//# sourceMappingURL=Dropdown.js.map
